import { ReactElement, useEffect, useRef } from 'react'

import { EInvoicingSetupContextProvider } from '@features/eInvoicing/context/EInvoicingSetupContext'
import { EInvoicingDashboardBanner } from '@features/eInvoicing/elements/EinvoicingDashboardBanner'

import { quoteEditorVariants } from '../../constants/variants/quoteEditorVariants'
import { recurringInvoiceEditorVariants } from '../../constants/variants/recurringInvoiceEditorVariants'
import { useInvoiceEditorActions } from '../../contexts/invoiceEditorActionsContext'
import { useInvoiceEditor } from '../../contexts/invoiceEditorContext'
import { useInvoiceEditorForm } from '../../contexts/invoiceEditorFormContext'
import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'
import { InvoiceEditorView } from '../../enums/invoiceEditorView'
import { InvoiceEditorForm } from './elements/InvoiceEditorForm'
import { InvoiceEditorPreview } from './elements/InvoiceEditorPreview'
import { InvoiceEditorProcessingOverlay } from './elements/InvoiceEditorProcessingOverlay'
import * as Styled from './styles'

const nonInvoiceEditorVariants: InvoiceEditorVariant[] = [
  InvoiceEditorVariant.CreditNoteFromInvoice,
  ...quoteEditorVariants,
  ...recurringInvoiceEditorVariants,
]

export const InvoiceEditorContent = (): ReactElement => {
  const hasTrackedViewed = useRef(false)
  const { view, invoiceEditorVariant } = useInvoiceEditor()
  const { displayedInvoiceNumber, isLoading, trackInvoiceEditor } = useInvoiceEditorForm()
  const { isSubmitting } = useInvoiceEditorActions()

  const isPreviewSelected = view === InvoiceEditorView.Preview
  const isInvoiceVariant = !nonInvoiceEditorVariants.includes(invoiceEditorVariant)

  useEffect(() => {
    if (displayedInvoiceNumber && !hasTrackedViewed.current) {
      hasTrackedViewed.current = true
      trackInvoiceEditor('viewed')
    }
  }, [displayedInvoiceNumber, trackInvoiceEditor])

  return (
    <Styled.InvoiceEditorContentWrapper>
      {(isLoading || isSubmitting) && <InvoiceEditorProcessingOverlay />}
      {isPreviewSelected ? (
        <InvoiceEditorPreview />
      ) : (
        <>
          {isInvoiceVariant && (
            <EInvoicingSetupContextProvider>
              <EInvoicingDashboardBanner source="invoice-editor" />
            </EInvoicingSetupContextProvider>
          )}
          <InvoiceEditorForm />
        </>
      )}
    </Styled.InvoiceEditorContentWrapper>
  )
}
